// @flow
import i18n from "i18next";
import k from "src/i18n/keys"; /* eslint-disable react/no-unescaped-entities */
// @flow

import React, { Fragment } from "react";
import { connect } from "react-redux";
import {
  AuthDiv,
  AuthFormHeader,
  Button,
  ContainerLeftAligned,
} from "src/styles/auth";

import { logout } from "src/actions";

import { continueToApp } from "src/actions/auth";
import NavLinks from "src/components/auth/NavLinks";

type Props = {
  email: string,
  continueToApp: Function,
  logout: Function,
};

const MobileWebLanding = ({ logout }: Props) => (
  <Fragment>
    <AuthDiv>
      <AuthFormHeader>{i18n.t(k.CONTINUE_IN_APP)}</AuthFormHeader>
      <ContainerLeftAligned>
        {i18n.t(k.HEY_THERE_LOOKS_LIKE_YOU_RE_T)}
      </ContainerLeftAligned>
      <Button
        as="a"
        target="_blank"
        href={"https://unifizealpha.page.link/appstore"}
      >
        {i18n.t(k.CONTINUE_WITH_UNIFIZE_MOBILE_A)}
      </Button>
      <Button onClick={() => logout()}>{i18n.t(k.CANCEL)}</Button>
    </AuthDiv>
    <NavLinks />
  </Fragment>
);

export default connect(null, {
  continueToApp,
  logout,
})(MobileWebLanding);
